import compact from 'lodash/compact';
import flattenDeep from 'lodash/flattenDeep';
import forEach from 'lodash/forEach';
import isUndefined from 'lodash/isUndefined';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import {createSelector} from 'reselect';
import SpotUtils from 'utils/spot';
import {
    initialAmenities,
    initialReservationTypes
} from './filters-utils';

const getIsMonthly = state => state.searchRequest.monthly;
const getAllSpots = state => state.spots.data;
const getCurrentFilters = state => state.filters;
const getAllAmenities = state => state.filters.amenities;
const getAllReservationTypes = state => state.filters.reservationTypes;
const getPrice = state => state.filters.price;

export const getAmenities = createSelector(
    [getIsMonthly, getAllSpots, getCurrentFilters, getAllAmenities],
    (isMonthly, spots, filters, amenities) => {
        if (!spots.length) { return initialAmenities; }

        const ratesProp = (isMonthly) ? 'monthly_rates' : 'hourly_rates';
        const preparedSpots = SpotUtils.filter(spots, filters, isMonthly);

        // reset amenity counts
        forEach(amenities, amenity => {
            amenity.count = 0;
        });

        // populate amenities
        forEach(preparedSpots, spot => {
            const spotAmenities = [];

            forEach(spot[ratesProp], rate => {
                if (!rate.hidden) {
                    forEach(rate.amenities, amenity => { // eslint-disable-line max-nested-callbacks
                        if (spotAmenities.indexOf(amenity.slug) < 0) {
                            if (isUndefined(amenities[amenity.slug])) {
                                amenities[amenity.slug] = {
                                    slug: amenity.slug,
                                    name: amenity.name,
                                    count: 1
                                };
                            } else {
                                amenities[amenity.slug].count++;
                            }

                            spotAmenities.push(amenity.slug);
                        }
                    });
                }
            });
        });

        return amenities;
    }
);

export const getReservationTypes = createSelector(
    [getIsMonthly, getAllSpots, getCurrentFilters, getAllReservationTypes],
    (isMonthly, spots, filters, reservationTypes) => {
        if (!spots.length || !isMonthly) { return initialReservationTypes; }

        const preparedSpots = SpotUtils.filter(spots, filters, isMonthly);

        // reset all reservation types to inactive
        forEach(reservationTypes, reservationType => {
            reservationType.active = false;
        });

        // populate reservation types
        forEach(preparedSpots, spot => {
            forEach(spot.monthly_rates, rate => {
                if (rate.reservation_type !== 'all') {
                    if (!isUndefined(reservationTypes[rate.reservation_type])) {
                        reservationTypes[rate.reservation_type].active = true;
                    }
                }
            });
        });

        return reservationTypes;
    }
);

export const makeGetPriceRange = () => {
    return createSelector(
        [getIsMonthly, getAllSpots, getCurrentFilters, getPrice],
        (isMonthly, spots, filters, price) => {
            const range = {
                priceLow: 0,
                priceHigh: 0
            };

            if (!spots.length) { return range; }

            const preparedSpots = SpotUtils.filter(spots, filters, isMonthly);
            const prices = sortBy(compact(flattenDeep(map(preparedSpots, spot => {
                return spot.selectedRate.price;
            }))), newPrice => {
                return newPrice;
            });

            if (prices.length) {
                range.priceLow = Math.ceil(prices[0] / 100);
                range.priceHigh = Math.ceil(prices[prices.length - 1] / 100);
            }

            if (price && price < range.priceHigh) {
                range.priceHigh = price;
            }

            return range;
        }
    );
};
